import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 28, ...rest }) => (
  <motion.div className={className} initial={{ opacity: 0, y }} whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.12 }} transition={{ duration: 0.8, delay, ease }} {...rest}>
    {children}
  </motion.div>
);

// Masked line-by-line reveal on load.
export const MaskLines = ({ lines, className = "", delay = 0.1, as = "h1", testid }) => {
  const Tag = as;
  return (
    <Tag className={className} data-testid={testid}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.1em]">
          <motion.span className="block" initial={{ y: "105%" }} animate={{ y: 0 }}
            transition={{ duration: 1, delay: delay + i * 0.12, ease }}>
            {l}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export const FadeIn = ({ children, delay = 0, className = "" }) => (
  <motion.div className={className} initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8, delay, ease }}>
    {children}
  </motion.div>
);
